const utilsFetch = {
  process: async r => {
    let data;

    try {
      data = await r.json();
    } catch (error) {
      error.status = r.status;
      throw error;
    }

    if (!r.ok) {
      const error = new Error((data && data.message) || `Request failed with status ${r.status}`);

      if (data && typeof data === 'object') {
        Object.assign(error, data);
      }

      error.status = r.status;
      throw error;
    }

    return data;
  },
};

export default utilsFetch;
